'use client'

import { useRef } from 'react'

import { IMaskInput } from 'react-imask'

import { Range } from '@/components'

import styles from './RangeSelector.module.scss'

export const RangeSelector = ({
  control,
  name,
  label,
  min = 1,
  max,
  value,
  onChange
}) => {
  const ref = useRef()

  return (
    <div className={styles.rangeSelector} onClick={() => ref.current.focus()}>
      <Range control={control} min={min} max={max} name={name} />

      <div className={styles.rangeSelector__quantity}>
        <IMaskInput
          inputRef={ref}
          type="tel"
          inputMode="numeric"
          autoComplete="off"
          min={min}
          max={max}
          maxLength={4}
          mask={Number}
          value={`${value}`}
          id={`${name}--clickable`}
          onAccept={onChange}
          onBlur={({ target }) => {
            if (!target.value) onChange(min)
          }}
          className={styles.rangeSelector__input}
        />

        <hr className={styles.rangeSelector__divider} />
        <span>{label}</span>
      </div>
    </div>
  )
}
